import { Input, Component, OnInit } from '@angular/core';
import { ModalController, NavParams, NavController } from '../../../node_modules/@ionic/angular';
import { StreamingMedia, StreamingVideoOptions } from '@ionic-native/streaming-media/ngx';
import { Storage } from '@ionic/storage';

@Component({
  selector: 'app-view-appointment',
  templateUrl: './view-appointment.page.html',
  styleUrls: ['./view-appointment.page.scss'],
})
export class ViewAppointmentPage implements OnInit {
  @Input() appointment: string;
  @Input() section: string;

  appointmentData:any = [];
  sectionData:any = '';
  role:any;

  constructor(
    public modalCtrl: ModalController,
    public navParams: NavParams,
    public navCtrl: NavController,
    private streamingMedia: StreamingMedia,
    public storage: Storage,
  ) {
    console.log(navParams.get('appointment'));

    this.appointmentData = navParams.get('appointment');
    this.sectionData = navParams.get('section');

    console.log(this.appointmentData);
  }

  ionViewWillEnter(){
    this.storage.get('user').then((val) => {
      if(val!=null){
        this.role = val.role;
      }
    });
  }

  ngOnInit() { 
  }

  async dismiss(){
    await this.modalCtrl.dismiss();
  }

  async payOpt(a){
    await this.modalCtrl.dismiss();

    this.navCtrl.navigateForward(['/payment-option', {
      appointment: JSON.stringify(a)
    }]);
  }

  playMedia(url){
    let options: StreamingVideoOptions = {
      successCallback: () => { console.log('Video played') },
      errorCallback: (e) => { console.log('Error streaming') },
      orientation: 'portrate',
      shouldAutoClose: true,
      controls: false
    };
    
    this.streamingMedia.playVideo(url, options);
  }

}
